import React from 'react';
import Modal from 'cccisd-modal';
import IconNotebook from 'cccisd-icons/notebook';
import TrackingReportComponent from '../../TrackingReport';

const TrackingReport = ({ member, memberDisplayName }) => {
    const trigger = (
        <button className="btn btn-sm btn-secondary" type="button">
            <IconNotebook spaceRight />
            Tracking Report
        </button>
    );

    return (
        <Modal
            title={`Tracking Report - ${memberDisplayName}`}
            size="large"
            trigger={trigger}
            render={({ closeModal }) => {
                return (
                    <div>
                        <TrackingReportComponent
                            pawnId={member.pawn.pawnId}
                            pawnHash={member.pawn.pawnHash}
                            displayName={memberDisplayName}
                        />
                        <div className="mt-4">
                            <button className="btn btn-secondary" type="button" onClick={() => closeModal()}>
                                Close
                            </button>
                        </div>
                    </div>
                );
            }}
        />
    );
};

export default TrackingReport;
